import React from "react";

// UI Library
import H3Text from '@Uilib/h3Text';

// Constants and Helpers
import Helpers from '@Apis/helpers';

// Ant Design
import { notification } from 'antd';
import { EditFilled, } from '@ant-design/icons';

function ViewDCLeftSectionAddress ({
  props,
  state,
  updateState,
  getRecipient,
}) {

  const {
    user,
    selectedDC,
  } = props;

  const {

  } = state;

  return (
    <div className="document-address-list">
      <div className="ant-row">
        <div className="ant-col-md-12 ant-col-xs-24">
          <div className="document-address__left">
            <div className="view-document__input-row__address-icon-wrapper">
              <H3Text text="Source" className="document-address__title" />
              {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.UPDATE, user) && (
                <div
                  className="view-document__input-row__address-icon"
                >
                {selectedDC?.status !== 'VOID' && (<EditFilled
                  onClick={() => {
                    if(selectedDC?.e_way_bills?.length > 0) {
                      notification.open({
                        type: 'error',
                        message: 'Cannot update address after e-way bill is generated',
                        duration: 4,
                        placement: 'top',
                      });
                    } else {
                      updateState({
                      selectedAddressType: 'SOURCE',
                      showAddressDrawer: true,
                      });
                      }
                    }
                  }
                />)}
                </div>
              )}
            </div>  
            {
              selectedDC?.source_tenant_department_info ? <H3Text text={selectedDC?.source_tenant_department_info?.source_tenant_name} className="document-address__details" /> : <H3Text text={selectedDC?.tenant_name} className="document-address__details" />
            }
            {(selectedDC?.source_tenant_department_info || selectedDC?.department_name) && (
              <div style={{ display: 'flex' }}>
                <H3Text text="Department:" className="document-address__details" />
              &nbsp;
                {selectedDC?.source_tenant_department_info
                  ? (
                    <H3Text
                      text={` ${selectedDC?.source_tenant_department_info?.department_name}`}
                      className="document-address__details"
                    />
                  )
                  : (
                    <H3Text
                      text={` ${selectedDC?.department_name}`}
                      className="document-address__details"
                    />
                  )}
              </div>
            )}
            {selectedDC?.source_department_info && <H3Text text={selectedDC?.source_department_info?.address1} className="document-address__details" />}
            {selectedDC?.source_address && (
              <H3Text
                text={selectedDC?.source_address?.address1}
                className="document-address__details"
              />
            )}
            {selectedDC?.source_address && (
              <H3Text
                text={`${selectedDC?.source_address?.city}, ${selectedDC?.source_address?.state} ${selectedDC?.source_address?.postal_code}`}
                className="document-address__details"
              />
            )}
          </div>
        </div>
        <div className="ant-col-md-12 ant-col-xs-24">
          <div className="document-address__right">
            <div className="view-document__input-row__address-icon-wrapper">
              <H3Text text="Destination" className="document-address__title" />
              {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.UPDATE, user) && (
                <div
                  className="view-document__input-row__address-icon"
                >
                {selectedDC?.status !== 'VOID' && (<EditFilled
                  onClick={() => {
                    if(selectedDC?.e_way_bills?.length > 0) {
                      notification.open({
                        type: 'error',
                        message: 'Cannot update address after e-way bill is generated',
                        duration: 4,
                        placement: 'top',
                      });
                    } else {
                      updateState({
                      selectedAddressType: 'DESTINATION',
                      showAddressDrawer: true,
                      });
                      }
                    }
                  }
                />)}
                </div>
              )}
            </div>
            {getRecipient()?.recipient && <H3Text text={getRecipient()?.recipient} className="document-address__details" />}
            { selectedDC?.destination_tenant_department_info && (
              <React.Fragment>
                <div style={{ display: 'flex' }}>
                  <div style={{ fontWeight: '600' }}>
                    <H3Text text="Department: " className="document-address__details" />
                  </div>
                  &nbsp;
                  <H3Text
                    text={` ${selectedDC?.destination_tenant_department_info?.department_name}`}
                    className="document-address__details"
                  />
                </div>
              </React.Fragment>
            )}
            {selectedDC?.destination_address && <H3Text text={selectedDC?.destination_address?.address1} className="document-address__details" />}
            {selectedDC?.destination_address && (
              <H3Text
                text={`${selectedDC?.destination_address?.city}, ${selectedDC?.destination_address?.state} ${selectedDC?.destination_address?.postal_code}`}
                className="document-address__details"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
};

export default ViewDCLeftSectionAddress;